import { useFeatureFlagsStore } from "@src/stores/featureFlags";
import type { FeatureFlagNamesToValues } from "@src/stores/featureFlags";

type UseFeatureFlags = () => FeatureFlagNamesToValues;

export const useFeatureFlags: UseFeatureFlags = () =>
  useFeatureFlagsStore(store => store.featureFlags);
